<script lang="ts">
  import { openNewCompose } from "../gmail/compose";
  import { haptic } from "../gestures/haptic";

  function onTap() {
    haptic("light");
    openNewCompose();
  }
</script>

<button class="fab" onclick={onTap} aria-label="Composer un nouveau mail">
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>

<style>
  .fab {
    position: fixed;
    /* La tab bar fait 52px : le FAB flotte au-dessus d'elle, pas dessus. */
    bottom: calc(env(safe-area-inset-bottom) + 72px);
    right: 16px;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--accent);
    color: var(--accent-fg);
    border: none;
    cursor: pointer;
    display: grid;
    place-items: center;
    box-shadow: var(--shadow-pop);
    z-index: 16;
    transition: transform 100ms cubic-bezier(0.32, 0.72, 0, 1),
                box-shadow 100ms;
    -webkit-tap-highlight-color: transparent;
  }
  .fab:active {
    transform: scale(0.94);
    box-shadow:
      0 3px 10px color-mix(in srgb, var(--accent) 36%, transparent),
      0 1px 2px rgba(0, 0, 0, 0.1);
  }
</style>
